import React from "react"
import styled from "styled-components"
import { StaticQuery } from "gatsby"
import { Grid } from "../../atoms/grid"
import Img from "gatsby-image"
import { Settings } from "../../../styles/theme"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const Teamstyle = styled.div`
  position: relative;
  .grid-item {
    max-width: 50%;
    width: 50%;
    padding: 2rem 0;
    @media screen and (max-width: ${Settings.sizeM}) {
      max-width: 100%;
    }
  }
  .grid-container {
    > div {
      align-items: flex-start !important;
      .gatsby-image-wrapper {
        max-height: 200px;
        width: 100%;
      }
      > div {
        &:first-of-type {
          flex: 1 1 30%;
        }
        &:last-of-type {
          flex: 1 1 55%;
        }
      }
    }
  }
  .grid-content {
    padding: 0.5rem 1rem;
    p,
    h4 {
      color: ${Settings.primaryColor};
    }
    p {
      margin-top: 0;
    }
    h4 {
      margin-bottom: 0;
      font-weight: 700;
      font-size: 1.2rem;
    }
    a {
      font-weight: 700;
    }
  }
  .popup {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 999;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    pointer-events: none;
    opacity: 0;
    .close {
      position: absolute;
      z-index: 1000;
      top: 1rem;
      right: 1rem;
      font-weight: 700;
      cursor: pointer;
      color: ${Settings.secondaryColor};
    }
    > div {
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      max-height: 80vh;
      overflow-y: scroll;
    }
    h3 {
      font-size: 1.5rem;
      color: ${Settings.primaryColor};
    }
    h4 {
      color: ${Settings.secondaryColor};
      margin: 0;
      font-size: 1.2rem;
    }
    .popupContent {
      padding: 3.5rem 0;
      height: 100%;
    }
    .grid-wrapper {
      > div {
        align-items: stretch;
      }
    }
  }
  .popup.show {
    opacity: 1;
    pointer-events: all;
  }
  .descriptionShort {
    p {
      display: none;
    }
    hr {
      display: none;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
    }
    h5 {
      font-size: 1.2rem;
    }
    h6 {
      font-size: 1rem;
      b {
        font-weight: 300;
      }
    }
    h5,
    h6 {
      color: ${Settings.primaryColor};
    }
    .more {
      text-decoration: underline;
      color: ${Settings.secondaryColor};
      font-weight: 300;
      cursor: pointer;
      position: relative;
      top: 1rem;
    }
  }
  .flex-start {
    > div {
      align-items: flex-start;
    }
  }
  .stack-30 {
    flex: 1 1 30%;
    .gatsby-image-wrapper {
      max-width: 50%;
      margin: 0 auto;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
  .stack-70 {
    flex: 1 1 70%;
    @media screen and (max-width: ${Settings.sizeM}) {
      flex: 1 1 100%;
    }
  }
`

export const Team = () => (
  <StaticQuery
    query={graphql`
      query TeamQuery {
        allContentfulTeam {
          edges {
            node {
              staffMembers {
                title
                email
                job
                profile {
                  id
                  fluid {
                    ...GatsbyContentfulFluid
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <Teamstyle>
        <div className="constraint">
          <Grid columns={2}>
            {data.allContentfulTeam.edges[0].node.staffMembers.map(
              (member, i) => (
                <div className="grid-item grid-container">
                  <Grid columns={2} unstack>
                    <div>
                      <Img fluid={member.profile.fluid} />
                    </div>
                    <div>
                      <div className="constraint grid-content">
                        <h4>{member.title}</h4>
                        <p>{member.job}</p>
                        {member.email ? <a>{member.email}</a> : ""}
                      </div>
                    </div>
                  </Grid>
                </div>
              )
            )}
          </Grid>
        </div>
      </Teamstyle>
    )}
  />
)

export const TeamFlexi = ({
  data,
  toggle,
  selected,
  togglePopup,
  setSelected,
}) => (
  <Teamstyle>
    <div className="constraint flex-start">
      <Grid columns={2}>
        {data.nestedContent.map((member, i) => (
          <div
            className="grid-item grid-container descriptionShort"
            onClick={() => {
              togglePopup()
              setSelected(i)
            }}
          >
            <Grid columns={2} unstack>
              <div>
                <Img fluid={member.image.fluid} />
              </div>
              <div>
                <div className="constraint grid-content">
                  {documentToReactComponents(member.content.json)}
                  <a className="more">More Info</a>
                </div>
              </div>
            </Grid>
          </div>
        ))}
      </Grid>
    </div>
    <div className={toggle ? "popup show" : "popup"}>
      <div className="grid-wrapper">
        <span
          className="close"
          onClick={() => {
            togglePopup()
          }}
        >
          X
        </span>
        <Grid columns={2}>
          <div className="stack-30">
            <div style={{ padding: "2rem" }}>
              <div>
                <Img fluid={data.nestedContent[selected].image.fluid} />
              </div>
            </div>
          </div>
          <div className="stack-70">
            <div className="constraint popupContent">
              {documentToReactComponents(
                data.nestedContent[selected].content.json
              )}
            </div>
          </div>
        </Grid>
      </div>
    </div>
  </Teamstyle>
)
